import { useTranslation } from 'react-i18next';
import { type CardDetailsGroup } from '../types';
import GroupHeader from '../GroupHeader';
import { type CardStatusToDisplay, NotRequestedCardStatus } from '../types';
import { type FlexflowCardStatus } from '../../types';
import Grid2 from '@mui/material/Unstable_Grid2';
import {
  type ContractPayflowStatus,
  getStatusToDisplay
} from 'src/modules/Flexflow/Contracts/ContractStatusAfterInvitation';
import { CardInformationSection } from './CardInformationSection';
import { ActionsSection } from './ActionsSection';

export const maybeCardStatus = (data: CardDetailsGroup | undefined, notInvited?: boolean): CardStatusToDisplay | '' => {
  if (notInvited) {
    return '';
  }

  if (!data?.createdAt) {
    return NotRequestedCardStatus.NOT_REQUESTED;
  }

  return data?.status;
};

type CardGroupProps = {
  data?: CardDetailsGroup;
  payflowUserId: number;
  notInvited?: boolean;
  employeeDisabled?: boolean;
  payflowStatus?: ContractPayflowStatus;
};

const CardGroup = ({
  data,
  payflowUserId,
  notInvited = false,
  employeeDisabled = false,
  payflowStatus
}: CardGroupProps) => {
  const { t } = useTranslation(['flexflow']);
  const cardStatus = maybeCardStatus(data, notInvited);
  const statusToDisplay = getStatusToDisplay(payflowStatus, cardStatus as FlexflowCardStatus);

  return (
    <Grid2 container>
      <GroupHeader marginTop={32}>{t('card information', { ns: 'flexflow' })}</GroupHeader>
      <CardInformationSection data={data} />

      <ActionsSection
        cardStatus={cardStatus || undefined}
        statusToDisplay={statusToDisplay || undefined}
        data={data}
        payflowUserId={payflowUserId}
        employeeDisabled={employeeDisabled}
      />
    </Grid2>
  );
};

export default CardGroup;
